var SPINNER_SIZE = '180px';
var SPINNER_THICKNESS = '25px';
export default (function (_ref) {
  var colors = _ref.colors;
  return {
    '@keyframes fluid': {
      '0%': {
        backgroundColor: colors.secondary,
        height: '6px',
        top: '13px'
      },
      '25%': {
        backgroundColor: colors.primary,
        height: '32px',
        top: 0
      },
      '50%': {
        backgroundColor: colors.secondary,
        height: '6px',
        top: '13px'
      },
      '100%': {
        backgroundColor: colors.secondary,
        height: '6px',
        top: '13px'
      }
    },
    fluid: {
      minHeight: '32px',
      padding: '32px 0',
      textAlign: 'center',
      width: '100%'
    },
    fluid__inline: {
      display: 'inline-block',
      padding: 0
    },
    fluidWrapper: {
      height: '32px',
      margin: '0 auto',
      position: 'relative',
      width: '53px'
    },
    fluidBar: {
      animation: 'fluid 1.5s infinite ease-in-out',
      backgroundColor: colors.secondary,
      display: 'block',
      width: '9px',
      height: '6px',
      position: 'absolute',
      top: '13px'
    },
    '@keyframes sectionSpinningA': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '35%': {
        transform: 'rotate(90deg)'
      },
      '50%': {
        transform: 'rotate(180deg)'
      },
      '65%': {
        transform: 'rotate(270deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes sectionSpinningB': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '15%': {
        transform: 'rotate(90deg)'
      },
      '50%': {
        transform: 'rotate(180deg)'
      },
      '85%': {
        transform: 'rotate(270deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    section: {
      position: 'relative',
      width: SPINNER_SIZE,
      height: SPINNER_SIZE,
      margin: '50px auto',
      '&:after': {
        content: '""',
        display: 'block',
        width: '100%',
        height: '100%',
        position: 'absolute',
        borderRadius: '50%',
        border: "".concat(SPINNER_THICKNESS, " solid ").concat(colors.grayLighter)
      }
    },
    sectionSpinner: {
      borderRadius: '50%',
      width: '100%',
      height: '100%',
      position: 'absolute',
      zIndex: 1,
      borderTop: "".concat(SPINNER_THICKNESS, " solid ").concat(colors.primary),
      borderRight: "".concat(SPINNER_THICKNESS, " solid ").concat(colors.primary),
      borderBottom: "".concat(SPINNER_THICKNESS, " solid ").concat(colors.primary),
      borderLeft: "".concat(SPINNER_THICKNESS, " solid transparent"),
      animation: 'sectionSpinningA 5s ease infinite',
      '&:last-of-type': {
        animationName: 'sectionSpinningB'
      }
    },
    sectionBar: {
      position: 'absolute',
      backgroundColor: colors.white,
      height: SPINNER_THICKNESS,
      transformOrigin: '0px 0px',
      width: '2px',
      zIndex: 2
    },
    sectionBar__1: {
      left: '90px',
      top: 0
    },
    sectionBar__2: {
      left: '32px',
      top: '21px'
    },
    sectionBar__3: {
      left: '1px',
      top: '75px'
    },
    sectionBar__4: {
      left: '12px',
      top: '135px'
    },
    sectionBar__5: {
      left: '60px',
      top: '175px'
    },
    sectionBar__6: {
      left: '120px',
      top: '175px'
    },
    sectionBar__7: {
      left: '168px',
      top: '135px'
    },
    sectionBar__8: {
      left: '179px',
      top: '75px'
    },
    sectionBar__9: {
      left: '148px',
      top: '21px'
    }
  };
});